import { render, staticRenderFns } from "./IconYearOfExperience.vue?vue&type=template&id=23eb6a86"
import script from "./IconYearOfExperience.vue?vue&type=script&lang=js"
export * from "./IconYearOfExperience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports